<template>
  <div class="not-voting-table" :class="className" v-inview="{ callback: onInview }">
    <h3 class="not-voting-table__title">不投票的人在哪？</h3>
    <div class="not-voting-table__layout">
      <table class="not-voting-table__table">
        <thead class="not-voting-table__head">
          <tr class="not-voting-table__head-row" :style="{ backgroundColor: color }">
            <th class="not-voting-table__head-col">縣市</th>
            <th class="not-voting-table__head-col">未投票數</th>
            <th class="not-voting-table__head-col">未投票率</th>
          </tr>
        </thead>
          <tbody class="not-voting-table__body" >
            <tr class="not-voting-table__body-row"
              v-for="({ county, notVotes, notProportion }, index) in data"
              :key="index"
            >
              <td class="not-voting-table__body-col">{{ county }}</td>
              <td class="not-voting-table__body-col">{{ notVotes | numeric }}</td>
              <td class="not-voting-table__body-col">{{ notProportion | percentage }}</td>
            </tr>
          </tbody>
      </table>
    </div>
    <div class="not-voting-table__read-more" @click="onReadMoreClick">
      <p>{{ readMoreWording }}</p></div>
  </div>
</template>

<script>
export default {
  name: 'NotVotingTable',
  data () {
    return {
      isInview: false,
      isListOpen: false
    }
  },
  props: {
    color: { type: String, default: '#a1a1a1' },
    data: { type: Array, default: () => [] }
  },
  computed: {
    className () {
      return {
        'not-voting-table--inview': this.isInview,
        'not-voting-table--open': this.isListOpen
      }
    },
    readMoreWording () {
      return this.isListOpen ? '收合更多' : '展開更多'
    }
  },
  methods: {
    onInview () {
      this.isInview = true
    },
    onReadMoreClick () {
      if (!this.isListOpen) {
        this.$ga('newmedia.send', {
          'hitType': 'event',
          'eventCategory': 'Read',
          'eventAction': 'Click',
          'eventLabel': 'NonVoteCity'
        })
      }
      this.isListOpen = !this.isListOpen
    }
  },
  mounted () {}
}
</script>

<style lang="scss">
.not-voting-table {
  $comp: &;
  position: relative;
  width: 100%;
  margin-top: -24px;
  color: #1a1a1a;
  opacity: 0;
  transform: translateY(10px);
  transition:
    opacity 0.4s ease 0.4s,
    transform 0.7s ease 0.4s;

  &__title {
    color: #1a1a1a;
    font-size: 1.125em;
    font-weight: bold;
    text-align: center;
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 1.25em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1.5em;
    }
  }

  &__layout {
    max-height: 234px;
    margin-top: 17px;
    overflow: hidden;
    transition: max-height 0.7s;

    @include rwd($RWD_TABLET_SMALL) {
      max-height: 276px;
    }

    @include rwd($RWD_TABLET) {
      max-height: 312px;
      margin-top: 20px;
    }
  }

  &--open &__layout {
    max-height: 1400px;

    transition: max-height 0.7s;
  }

  &__table {
    position: relative;
    width: 100%;
    text-align: center;
    border-spacing: 1px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
  }

  &__head {}
  &__head-row {}
  &__head-col {
    width: 33.33%;
    padding: 5px 0;
    font-size: 0.8125rem;
    font-weight: normal;
    border: 1px solid white;

    @include rwd($RWD_TABLET_SMALL) {
      font-size: 0.9375rem;
    }

    @include rwd($RWD_TABLET) {
      padding: 8px 0;
      font-size: 1rem;
    }
  }

  &__body {}
  &__body-row {
    // width: 100%;
  }
  &__body-row:nth-child(2n-1) {
    background-color: #e6e6e6;
  }
  &__body-col {
    padding: 8px 0;
    border: 1px solid white;

    @include rwd($RWD_TABLET_SMALL) {
      padding: 12px 0;
      font-size: 1.125rem;
    }

    @include rwd($RWD_TABLET) {
      padding: 15px 0;
      font-size: 1.25rem;
    }
  }

  &__read-more {
    text-align: center;
    cursor: pointer;
  }

  &__read-more p {
    position: relative;
    display: inline-block;
    width: 33.33%;
    margin: 0;
    padding: 5px 0;
    line-height: 1em;
    background-color: #a1a1a1;
    color: #ffffff;
    font-size: 0.75em;
    @include rwd($RWD_TABLET_SMALL) {
      padding: 7px 0;
      font-size: 0.875em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 0.9375em;
    }

    &:before {
      content: "";
      position: relative;
      display: inline-block;
      margin-right: 5px;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid #ffffff;
      vertical-align: middle;

      @include rwd($RWD_TABLET_SMALL) {
        margin-right: 8px;
      }
    }
  }

  &--open &__read-more p {
    &::before {
      transform: rotate(180deg);
    }
  }

  &--inview {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
